<script>
    import axios from 'axios';

    export default {
        name: 'AxiosPlugin',
        install: function (Vue, name = '$http') {
            Object.defineProperty(Vue.prototype, name, {value: axios});
        }
    }
</script>